import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer class="pt-5 pb-4 mt-5">
      <div class="container">
        <div class="row">
          <div class="col-md-4 mb-4">
            <Link to="/">
              <img 
                src="/shivam motor logo.jpeg" 
                alt="Shivam Moto Logo" 
                style={{ height: '80px', borderRadius: '50%', marginBottom: '20px' }} 
              />
            </Link>
            <p>House of Multibrand – New & Used Bikes. 25+ years of trust.</p>
            <div>
              <a 
                href="https://www.instagram.com/shivam_moto_official?igsh=MWthNWlsZTZsNzJseg%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                class="social-icon me-2"
              >
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#" class="social-icon">
                <i class="fab fa-google"></i>
              </a>
            </div>
          </div>
          <div class="col-md-2 mb-4">
            <h5 class="text-white">Explore</h5>
            <ul class="list-unstyled">
              <li>
                <Link to="/new-bikes" class="text-secondary text-decoration-none">
                  New Bikes
                </Link>
              </li>
              <li>
                <Link to="/old-bikes" class="text-secondary text-decoration-none">
                  Old Bikes
                </Link>
              </li>
              <li>
                <Link to="/exchange" class="text-secondary text-decoration-none">
                  Exchange
                </Link>
              </li>
            </ul>
          </div>
          <div class="col-md-3 mb-4">
            <h5 class="text-white">Contact</h5>
            <p><i class="fas fa-map-marker-alt me-2"></i>Mumbai - Pune Highway, Shivam Nagar</p>
            <p><i class="fas fa-phone-alt me-2"></i>+91 98765 43210</p>
          </div>
          <div class="col-md-3 mb-4">
            <h5 class="text-white">Hours</h5>
            <p>Mon-Sun: 10am – 8pm</p>
          </div>
        </div>
        <hr class="bg-secondary" />
        <p class="text-center text-secondary mt-3">© 2026 Shivam Moto | All Rights Reserved</p>
      </div>
    </footer>
  );
}
